import { Sun, Moon, Bell } from 'lucide-react'
import { useUIStore } from '@/store/uiStore'
import { useAuthStore } from '@/store/authStore'
import { getDaysRemaining } from '@/lib/utils'
import { Badge } from '@/components/ui/Badge'

interface TopBarProps {
  title?: string
}

export function TopBar({ title }: TopBarProps) {
  const { theme, toggleTheme } = useUIStore()
  const { user } = useAuthStore()

  const daysLeft = user?.trialEndsAt ? getDaysRemaining(user.trialEndsAt) : 0
  const isTrialing = user?.subscriptionStatus === 'trial'
  const isExpired = user?.subscriptionStatus === 'expired'

  return (
    <header className="sticky top-0 z-30 bg-background/80 backdrop-blur-sm border-b border-border px-4 md:px-6 py-3">
      <div className="flex items-center justify-between">
        <div>
          {title && <h1 className="font-semibold text-foreground">{title}</h1>}
        </div>

        <div className="flex items-center gap-3">
          {isTrialing && daysLeft <= 7 && (
            <Badge
              label={`${daysLeft}d trial left`}
              variant="warning"
              dot
              className="hidden sm:flex"
            />
          )}
          {isExpired && (
            <Badge
              label="Trial expired"
              variant="error"
              dot
              className="hidden sm:flex"
            />
          )}

          <button
            onClick={toggleTheme}
            className="w-8 h-8 rounded-lg flex items-center justify-center text-muted hover:text-foreground hover:bg-surface transition-colors"
          >
            {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>

          <button className="w-8 h-8 rounded-lg flex items-center justify-center text-muted hover:text-foreground hover:bg-surface transition-colors relative">
            <Bell className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  )
}
